import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import Box from "@mui/material/Box";
import { refreshSignalR } from "../../../src/Dashboard/ducks/devicesDuck";

const statusColor = (bgColor) =>
  bgColor === "red" ? "error.main" : bgColor === "orange" ? "secondary.main" : bgColor === "green" ? "primary.main" : undefined;

const alarmColor = (category, isActive) => {
  if (isActive && (category === "SampleCondition" || category === "Device")) return "error.main";
  if (isActive && category === "Warning") return "secondary.main";
  return undefined;
};

const SensorContent = ({ sensor, sys, entries }) => {
  const dispatch = useDispatch();

  const sensorData = sensor?.sensorData;
  const deviceHWID = entries?.find((entry) => entry?.hwId === sensorData?.hwId);

  useEffect(() => {
    if (!sensorData?.hwId || !sys) return;
    dispatch(refreshSignalR({ hwId: sensorData.hwId, payload: { ...sys }, delay: 700 }));
  }, []);

  if (!sensorData) return null;

  return (
    <Box sx={{ pb: 0.5 }}>
      <Box sx={{ display: "flex", justifyContent: "center", fontSize: "0.75rem", color: statusColor(sensorData.deviceBgColor) }}>
        {deviceHWID?.name}
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {sensorData.measurements?.map((mes) => (
          <Box
            sx={{ display: "flex", flexWrap: "nowrap", justifyContent: "space-between", fontSize: "0.675rem", color: alarmColor(mes.category, mes.isActive) }}
            key={`${sensorData.hwId}${mes.displayName}`}
          >
            <Box>{mes.displayName}</Box>
            <Box sx={{ minWidth: 40, display: "flex", justifyContent: "flex-end", ml: 0.25 }}>
              <Box component="span">{mes.value}</Box>
              <Box component="span" sx={{ ml: 0.25 }}>{mes.unit}</Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SensorContent;
